import styled from 'styled-components';
import { colors, borderRadius as radius, smallShadow, spacing } from 'ui/theme';
import { CARD_BORDER_RADIUS, CARD_SIZES, CARD_VARIANTS, SHADOWS } from './constants';
import { CardProps } from './types';

type ContainerProps = Required<Pick<CardProps, 'borderRadius'>> & CardProps;

const Container = styled.div<ContainerProps>`
  width: 100%;
  margin: 0;
  padding: ${spacing.base};
  border-radius: ${({ borderRadius = 'none' }) => radius?.[borderRadius]};
  
  &[data-variant=${CARD_VARIANTS.DEFAULT}] {
    ${({ shadow }) => (shadow ? SHADOWS[shadow] : smallShadow)}
    background: ${colors.backgroundPrimary};
  }

  &[data-size=${CARD_SIZES.SMALL}] {
    padding: ${spacing.base};
  }

  &[data-size=${CARD_SIZES.MEDIUM}] {
    padding: ${spacing.plusHalf};
  }

  &[data-size=${CARD_SIZES.LARGE}] {
    padding: ${spacing.double};
  }
`;

export function Card({
  children,
  variant = CARD_VARIANTS.DEFAULT,
  size = CARD_SIZES.MEDIUM,
  borderRadius = CARD_BORDER_RADIUS.XL,
  shadow,
  ...props
}: CardProps) {
  return (
    <Container
      data-test="card"
      data-size={size}
      data-variant={variant}
      borderRadius={borderRadius}
      shadow={shadow}
      {...props}
    >
      {children}
    </Container>
  );
}
